import React, { useState } from 'react';
import { TopCountriesTrafficWidget } from '../TopCountriesTrafficWidget/TopCountriesTrafficWidget';
import { ReportWidgetLoader } from '../ReportWidgetLoader';
import { BaseWidgetProps } from '../types';
import { Direction, ReportName } from '@src/utils/enums';

export const TopCountriesAllowedTrafficWidget: React.FC<BaseWidgetProps> = (props) => {
  const [direction, setDirection] = useState<Direction>(Direction.Inbound);
  return (
    <ReportWidgetLoader hookProps={{ ...props, reportName: 'topCountriesAllowedTraffic', direction }}>

      {(data, error) => (
        <TopCountriesTrafficWidget
          title="Top countries allowed traffic"
          color="#3DAB3F"
          data={data}
          type="allowed"
          direction={direction}
          onDirectionChange={setDirection}
          reportPath={`/${props.customerId}/${props.serviceId}/insights/reports/${ReportName.TOP_15_ALLOWED_COUNTRIES}`}
          hasError={!!error}
        />
      )}
    </ReportWidgetLoader>
  );
};


